var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_175_49658",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 20,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99985 1.00012H21.4968V18.3481H2.99985V1.00012Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_175_49658)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2469 2.50012C8.75186 2.50012 6.31586 5.23812 6.31586 7.69512C6.31586 9.77412 5.73886 10.7351 5.22886 11.5831C4.81986 12.2641 4.49686 12.8021 4.49686 13.9711C4.66386 15.8571 5.90886 16.8481 12.2469 16.8481C18.5499 16.8481 19.8339 15.8131 19.9999 13.9061C19.9969 12.8021 19.6739 12.2641 19.2649 11.5831C18.7549 10.7351 18.1779 9.77412 18.1779 7.69512C18.1779 5.23812 15.7419 2.50012 12.2469 2.50012ZM12.2469 18.3481C7.57086 18.3481 3.34486 18.0181 2.99986 14.0351C2.99686 12.3871 3.49986 11.5491 3.94386 10.8111C4.39286 10.0631 4.81586 9.35812 4.81586 7.69512C4.81586 4.46212 7.80186 1.00012 12.2469 1.00012C16.6919 1.00012 19.6779 4.46212 19.6779 7.69512C19.6779 9.35812 20.1009 10.0631 20.5499 10.8111C20.9939 11.5491 21.4969 12.3871 21.4969 13.9711C21.1479 18.0181 16.9229 18.3481 12.2469 18.3481Z",
    fill: "#082A51"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1981 22.5001H12.1961C11.0751 22.4991 10.0141 22.0051 9.20906 21.1081C8.93206 20.8011 8.95706 20.3261 9.26506 20.0501C9.57306 19.7721 10.0471 19.7971 10.3241 20.1061C10.8421 20.6831 11.5071 21.0001 12.1971 21.0001H12.1981C12.8911 21.0001 13.5591 20.6831 14.0781 20.1051C14.3561 19.7981 14.8301 19.7731 15.1371 20.0501C15.4451 20.3271 15.4701 20.8021 15.1931 21.1091C14.3851 22.0061 13.3221 22.5001 12.1981 22.5001Z",
    fill: "#082A51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/icon-notification.a47291bdbd0bff501ceb0812452dc5a4.svg";
export { ForwardRef as ReactComponent };